import { render, staticRenderFns } from "./LeatherStamp.vue?vue&type=template&id=4b4bded8&scoped=true"
import script from "./LeatherStamp.vue?vue&type=script&lang=js"
export * from "./LeatherStamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4bded8",
  null
  
)

export default component.exports